import { config } from 'state/product/config'
import { Color } from 'state/color'
import { toggle } from 'state/product/fns/toggle'
import 'state/product/events'
import { addCurrency } from 'state/product/fns/addCurrency'
import { createDOMNodes } from 'state/product/fns/createDOMNodes'
import { createSwatch } from 'state/product/fns/createSwatch'
import { classList } from 'MK/DOM/fns/classList'
import { SKU } from 'state/product/sku'

// import { config } from 'state/product/config'

export class Product {
  constructor(product = {}) {
    Object.assign(this, {
      color: product.color,
      colorID: product.color.id,
      colors: {},
      id: product.id,
      is: {
        active: true,
        onSale: !!product.sP // && product.sP[0] !== product.p[0]
      },
      name: product.name,
      // price: product.p[0],
      price: (product.p.length > 1 ? product.p.map(addCurrency).join('-') : product.p.map(addCurrency)),
      productID: product.id,
      rating: (product.r && product.r[0] || 0.0),
      reviewCount: (product.r && product.r[1] || 0),
      // salePrice: product.p[1],
      salePrice: (product.sP && (product.sP.length > 1 ? product.sP.map(addCurrency).join('-') : product.sP.map(addCurrency))),
      sortOrder: {
        date: product.date,
        default: product.sortOrder,
        priceLow: product.pR,
        priceHigh: product.pR,
        rating: (product.r && product.r[0] || 0.0),
        title: product.name
      },
      // urlParameters: product.uP
    })

    // * Track default color ID on initialization.
    this.color.default = this.color.id

    // Iterate over each color ID for the product and initialize a Color/SKU-level object.
    for (let [id, attributes] of Object.entries(product.colors)) {
      // let productID = `${product.id}`.toLowerCase()

      let productID = product.id
      this.colors[id] = {
        alias: `${this.id}.${id}`,
        attributes: (product.commonAttributes ? [...product.commonAttributes, ...attributes] : attributes),
        color: {
          id: id
        },
        colorID: id,
        colormap: Color.by.id[id].family,
        id: id,
        is: {
          active: true,
          onSale: this.is.onSale
        },
        // name: Color.by.id[id].name,
        name: this.name,
        nameEncoded: Color.by.id[id].nameEncoded,
        price: this.price,
        productID: this.id,
        rating: this.rating,
        reviewCount: this.reviewCount,
        salePrice: this.salePrice,
        sortOrder: this.sortOrder,
        url: {

          image: `${process.env.PRODUCT_IMAGE_ROOT_URL_PATH}/category/${product.id}_${id}.jpg`,
          // product: `/p/${product.id}/${MK.page.slug}?sp=1`,
          product: `/p/${product.id}/${MK.page.slug}?sp=1&color=${Color.by.id[id].nameEncoded}`,
          // product: MK.page.id === 662 ? `/product/${Page.slug}${product.id}?sp=1&color=${id}` : `/product/${Page.slug}${product.id}?sp=1&color=${id}`, // New format ex: http://www.eddiebauer.com/product/womens-sweaters/21003757?showProducts=&color=722&sizetype=&size=
          swatch: `${process.env.PRODUCT_IMAGE_ROOT_URL_PATH}/swatch/${productID}_${id}.jpg`
        }
      }

      // Create hashmap of all color indexes
      Color.by.alias[this.colors[id].alias] = this.colors[id]
      Product.index.skus[this.colors[id].alias] = new SKU(this.colors[id])
    }

    // Create DOM nodes for the product instance
    Product.index.ids[this.id] = this
  }

  findActiveColor () {
    let activeColor = Object.values(this.colors).find(color => color.is.active)
    this.is.active = !!activeColor

    if (activeColor) {
      this.color.id = activeColor.id

    }

    return this.is.active
  }

  isActive () {
    if (this.colors[this.color.id].is.active) return true
    return this.findActiveColor()
  }

  createDOMNodes () {

    this.nodes = createDOMNodes(this, this.colors[this.color.id])

    Object.assign(this.nodes.image, {
      src: config.pixel,
      className: 'lazy'
    })

    this.nodes.image.setAttribute('data-original', `${this.colors[this.color.id].url.image}`)

    this.nodes.swatches = Object.values(this.colors).filter(color => color.is.active).map(color => {
      let swatch = createSwatch(this, color)
      swatch.className = this.color.id === color.id ? 'active lazy' : 'lazy'

      swatch.onclick = (event = {}) => {
        MK.events.emit('product:swatch:click', {
          color: color,
          product: this,
          swatch: swatch,
        })

        return false
      }

      let swatchElementContainer = document.createElement('li')
      swatchElementContainer.appendChild(swatch)
      this.nodes.swatchContainer.appendChild(swatchElementContainer)

      return swatch
    })

    this.nodes.swatchContainer.setAttribute('data-count', `${this.nodes.swatches.length}`)

    return this.nodes.container
  }
}

Object.assign(Product.prototype, {
  toggle
})


Product.display = {
  by: {
    color: MK.page.renderByColor,
    id: !MK.page.renderByColor,
    sku: MK.page.renderByColor
  }
}

// Initialize DOM nodes
Product.container = document.getElementById(config.selectors.id.container)
Product.nodes = {
  count: document.getElementById(config.selectors.id.count)
}

Product.sort = {
  order: 'default',
  reverse: false
}

// Initialize Product index
Product.index = {
  active: null,
  aliases: {},
  attributes: {},
  colors: {},
  ids: {},
  skus: {}
}